(() => {
  function setup(root) {
    if (!root || root.dataset.gleamReady) return;
    root.dataset.gleamReady = 'true';
    const sid = root.dataset.section;
    const info = root.querySelector('.product__info-container');
    const qty = root.querySelector('[id^="Quantity-Form-"]');
    const productForm = root.querySelector('product-form');
    const buy = productForm?.parentElement;
    if (qty && buy && info && qty.parentElement === info && buy.parentElement === info) {
      const row = document.createElement('div'); row.className = 'gleam-purchase-row';
      info.insertBefore(row, qty); buy.dataset.gleamBuy = ''; row.append(qty, buy);
    }
    const bar = root.querySelector('[data-gleam-sticky]');
    const button = root.querySelector('#ProductSubmitButton-' + sid);
    if (!bar || !button) return;
    const stickyButton = bar.querySelector('[data-gleam-add]');
    function sync() {
      const real = root.querySelector('#ProductSubmitButton-' + sid);
      const disabled = !real || real.disabled || real.getAttribute('aria-disabled') === 'true';
      stickyButton.disabled = disabled;
      stickyButton.setAttribute('aria-disabled', String(disabled));
      const price = root.querySelector('[id="price-' + sid + '"]');
      const current = price?.querySelector('.price--on-sale .price__sale .price-item--sale') ||
        price?.querySelector('.price__regular .price-item--regular');
      const compare = price?.querySelector('.price--on-sale .price__sale s.price-item--regular');
      const stickyPrice = bar.querySelector('[data-gleam-price]');
      if (current && stickyPrice) {
        const value = current.textContent.trim();
        if (value && stickyPrice.textContent !== value) stickyPrice.textContent = value;
      }
      const stickyCompare = bar.querySelector('[data-gleam-compare]');
      if (stickyCompare) {
        const value = compare?.textContent.trim() || '';
        stickyCompare.hidden = !value;
        if (value && stickyCompare.textContent !== value) stickyCompare.textContent = value;
      }
    }
    stickyButton.addEventListener('click', () => {
      const real = root.querySelector('#ProductSubmitButton-' + sid);
      if (real && !real.disabled) real.click();
    });
    const observer = new IntersectionObserver(entries => { bar.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0; }, { threshold: 0 });
    observer.observe(button);
    const mutation = new MutationObserver(sync);
    mutation.observe(info, {subtree:true,childList:true,attributes:true,attributeFilter:['disabled','aria-disabled']});
    sync();
    document.addEventListener('shopify:section:unload', event => { if(event.detail.sectionId === sid){observer.disconnect();mutation.disconnect();} });
  }
  document.querySelectorAll('.gleam-product').forEach(setup);
  document.addEventListener('shopify:section:load', event => setup(event.target.querySelector('.gleam-product')));
  document.addEventListener('product-info:loaded', event => setup(event.target.closest('.gleam-product')));
})();
